import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappNumber = '919959975995';
    const message = `New Contact Form Submission:\n\nName: ${formData.name}\nPhone: ${formData.phone}\nEmail: ${formData.email}\nMessage: ${formData.message}`;
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleWhatsApp = () => {
    const whatsappNumber = '919959975995';
    const message = 'Hi, I would like to get in touch with Vibe Dental Studio.';
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="contact" className="contact-section section-padding">
      <div className="container">
        <div className="contact-header fade-in">
          <h2 className="heading-1">Get In Touch</h2>
          <div className="section-divider"></div>
          <p className="body-large contact-subtitle">
            Schedule your appointment or reach out with any questions
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info fade-in">
            <div className="contact-info-card">
              <div className="info-icon-wrapper">
                <MapPin size={24} />
              </div>
              <div>
                <h3 className="heading-3">Visit Us</h3>
                <p className="body-regular">Vibe Dental Studio,Aruna residency, Plot 69, Diamond Heights Main Rd, Tellapur, Nallagandla, Telangana 500046</p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon-wrapper">
                <Phone size={24} />
              </div>
              <div>
                <h3 className="heading-3">Call Us</h3>
                <p className="body-regular">
                  <a href="tel:+919959975995">+91 99599 75995</a>
                </p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon-wrapper">
                <Mail size={24} />
              </div>
              <div>
                <h3 className="heading-3">Email Us</h3>
                <p className="body-regular">
                  <a href="mailto:vibedentalstudio@gmail.com">vibedentalstudio@gmail.com</a><br />
                  {/* <a href="mailto:appointments@vibedentalstudio.com">appointments@vibedentalstudio.com</a> */}
                </p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon-wrapper">
                <Clock size={24} />
              </div>
              <div>
                <h3 className="heading-3">Working Hours</h3>
                <p className="body-regular">
                  Mon - Sat: 9:30 AM - 1:30 PM, 4:30 PM - 8:00 PM<br />
                  Sunday: 4:30 PM - 8:00 PM
                </p>
              </div>
            </div>

            <button className="btn-primary whatsapp-btn" onClick={handleWhatsApp}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Contact via WhatsApp
            </button>
          </div>

          <div className="contact-form-wrapper fade-in">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="body-regular">Full Name *</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                  className="form-input"
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone" className="body-regular">Phone Number *</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  value={formData.phone}
                  onChange={handleChange}
                  required 
                  className="form-input"
                  placeholder="Enter your phone number"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="body-regular">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Enter your email address"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="body-regular">Message *</label>
                <textarea 
                  id="message" 
                  name="message" 
                  value={formData.message}
                  onChange={handleChange}
                  required 
                  rows="5" 
                  className="form-input form-textarea"
                  placeholder="Tell us about your dental needs or questions"
                />
              </div>

              <button type="submit" className="btn-primary submit-btn">
                <Send size={18} />
                Send Message
              </button>
            </form>
          </div>
        </div>

        <div className="contact-map fade-in">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.035786146818!2d78.304293!3d17.4580012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93006088749d%3A0xa03d13509a55509a!2sVibe%20Dental%20Studio!5e0!3m2!1sen!2sin!4v1774940257007!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Vibe Dental Studio Location"
          />
          
        </div>
      </div>
    </section>
  );
};

export default Contact;